// This file is generated by scripts/generate.mjs — do not edit.
// Source: svg/play-fill.svg
import { IconBase } from "./icon-base";
import type { IconProps } from "./types";

export function PlayFillIcon(props: IconProps) {
	return (
		<IconBase viewBox="0 0 16 16" {...props}>
			<path
				d="M3.75 3.14965C3.75 2.51472 4.26472 2 4.89965 2C5.12803 2 5.35124 2.06802 5.5408 2.19538L12.7312 7.02644C13.0555 7.24431 13.25 7.60934 13.25 8C13.25 8.39066 13.0555 8.75569 12.7312 8.97356L5.5408 13.8046C5.35124 13.932 5.12803 14 4.89965 14C4.26472 14 3.75 13.4853 3.75 12.8503V3.14965Z"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth="1.25"
				strokeLinecap="round"
			/>
		</IconBase>
	);
}
